<!-- IMPORTANT This is a template, used to easily 'copy paste' a new component -->

<template>
    <div class="wrapper">
        <section v-if="doneLoading"> <!-- When you are done loading stuff that takes long (from ex an API), show the content -->
            <h2>Template</h2>

            <!-- Readonly example -->
            <div class="group">
                <custom-input type="display" id="displayTest" name="displayTest" v-model="displayTest" label="Display test"/>
                <p>Another field: <span>This is used for fields that users are never able to edit</span></p>
            </div>

            <!-- Secret example -->
            <custom-input type="secret" id="secretTest" name="secretTest" v-model="secretTest" label="Secret test" v-on:toggleSecret="toggleSecretDisplay" :show-secret="showSecret"/>

            <!-- Input example -->
            <div class="group">
                <custom-input type="text" id="textTest" name="textTest" v-model="textTest" label="Input test"/>
                <small>You typed: {{ textTest }}</small>
            </div>

            <!-- Toggle example -->
            <div class="group">
                <custom-input type="toggle" id="toggleTest" name="toggleTest" v-model="toggleTest" label="Toggle test"/>
                <small>Toggle: {{ toggleTest ? 'on' : 'off' }}</small>
            </div>

            <!-- Custom input css example -->
            <div class="group">
                <custom-input type="text" id="cssTest" name="cssTest" label="Custom component CSS test" class="css-test"/>
            </div>

            <!-- TODO: Add -->
            <!-- vee-validate error example -->
            <!-- vee-validate error example (auto/manual error mode) -->
            <!-- color picker example -->
            <!-- time picker example -->
            <!-- modal example -->
            <!-- info pop-over example -->
        </section>

        <p v-if="showLoading && !doneLoading"> <!-- While we are fetching stuff, show a loading screen -->
            Loading template...
        </p>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import CustomInput from './additional/customInput';

export default {
    name: 'templateExample',
    components: {
        CustomInput
    },
    mixins: [
        Default
    ],
    data() {
        return {
            // Used for showing the loading screen example
            showLoading: false,
            doneLoading: false,

            // Used for readonly example
            displayTest: 'This is a readonly field, used for fields that could be accessible in a scenario',

            // Used for the secret example
            secretTest: '',
            secretRealText: 'Secret text, don\'t tell anyone shhhhhh!',
            secretFakeText: 'Random text to fill the text input when it is hidden',
            showSecret: false,

            // Used for the input example
            textTest: '',

            // Used for the toggle example
            toggleTest: false
        };
    },
    created() {
        window.setTimeout(() => { // Only show loading when it takes longer than X ms
            this.showLoading = true;
        }, 500);

        this.secretTest = this.secretFakeText;

        this.doneLoading = true; // Removes the loading screen and makes the new content visible
    },
    methods: {
        toggleSecretDisplay() {
            if (this.showSecret) {
                this.showSecret = false;
                this.secretTest = this.secretFakeText;
            } else {
                this.showSecret = true;
                this.secretTest = this.secretRealText;
            }
        }
    }
};
</script>

<!-- Some standard css -->
<style lang="scss" scoped>
    @import "../assets/styles/variables";

    .wrapper {
        margin: 5em auto;
        width: 50em;

        .custom-input {
            padding-bottom: 1em;
        }

        .group {
            padding-bottom: 1em;

            .custom-input { // Remove padding for grouped examples
                padding-bottom: 0;
            }
        }

        p {
            span {
                color: $secondary-color;
            }
        }
    }
</style>

<!-- CSS Test -->
<style lang="scss" scoped>
    /* To make the input's text red, this doesn't work */
    /*
    .css-test input {
        color: red;
    }
    */


    /* This does work */
    .css-test ::v-deep input { // ::v-deep in scss, otherwise >>>
        color: blue;
        background-color: white;
        width: 7em;
        -webkit-border-radius: 100px;
        -moz-border-radius: 100px;
        border-radius: 100px;
        text-align: center;
    }
</style>